import { State } from "../state";
import { Request } from "@/network/request";
// import Swal from "sweetalert2";
import i18n from "../../i18n";
import toast from "../../plugins/toast";

export default class agegroup {
  token = $cookies.get("token");
  breadcrumbsItems = [];
  tableData = {
    data: [],
    showData: {},
    headers: {
      id: {
        name: "id",
        keys: ["id"],
      },
      name: {
        name: "name",
        keys: ["name"],
      },
    },
    meta: {
      total: 1,
      per_page: 1,
      current_page: 1,
    },
  };

  getAgeState = new State();
  postAgeState = new State();
  editAgeState = new State();
  deleteAgeState = new State();
  showState = new State();

  async getAgeGroup(params) {
    let request = new Request({
      method: "get",
      endpoint: `/subject`,
      params: params,
      token: this.token,
    });

    await this.getAgeState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.tableData.data = value.data;
          this.tableData.meta = value.meta;
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
  postAgeGroup(payload) {
    let request = new Request({
      method: "post",
      endpoint: `/subject`,
      data: payload,
      token: this.token,
    });

    this.postAgeState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.getAgeGroup();
          toast(
            i18n.t("create success"),
            { timeout: 4000, rtl: true },
            "sucess"
          );
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
  editAgeGroup(payload, id) {
    let request = new Request({
      method: "put",
      endpoint: `/subject/${id}`,
      data: payload,
      token: this.token,
    });

    this.editAgeState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.getAgeGroup();
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
  async show(id) {
    let request = new Request({
      method: "get",
      endpoint: `/subject/${id}`,
      token: this.token,
    });

    await this.showState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.tableData.showData = value.data;
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
  deleteAgeGroup(id) {
    let request = new Request({
      method: "delete",
      endpoint: `/subject/${id}`,
      token: this.token,
    });

    this.deleteAgeState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.getAgeGroup();
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
}

export const ageGroup = new agegroup();
